/**
 * Shared visual / layout tokens for the universal data-table styling used by
 * the Contacts table (Manage Contacts) and the Account & Fund grid (My Profile).
 *
 * Renamed from `contactRowTokens.ts` (LPC-10778) — the original name suggested the
 * tokens were Contacts-only, but they describe the row background, row height/padding,
 * cell typography, status-tag sizing, page size, and per-column widths shared across
 * every grid that follows the LPC-10778 spec.
 */
export const TABLE_LAYOUT_TOKENS = {
  ROW_BG: "#FAFAFA",
  ROW_MIN_HEIGHT: 80,
  ROW_VERTICAL_PADDING: 10,
  ROW_SPACING: 10,
  CELL_TEXT_PX: 14,
  STATUS_TAG_PX: 12,
  CELL_VERTICAL_ALIGN: "middle",
  PAGE_SIZE: 10,
  COLUMN_WIDTHS: {
    account: { min: 150, flex: true },
    fund: { min: 150, flex: true },
    role: 170,
    documentAccess: 170,
    notifications: 170,
    status: 160,
    contact: 200,
    lastLogin: 120,
    action: 100,
  },
} as const;
